import { CS_API_ROLES } from '../constants/roles';
import apiRequestActionCreator from './apiRequestActionCreator';

export function fetchStatistics({ clientId, partnerId, ...params }, actionParams) {
    return apiRequestActionCreator({
        actionName: 'JIRA_STATISTICS',
        actionParams,
        params: {
            params: { ...params, clientIds: clientId, partnerIds: partnerId },
            url: 'jira/statistics/issues?size=50000',
        },
    });
}

export function setStatisticsCategory(payload) {
    return dispatch => {
        dispatch({
            payload,
            type: 'JIRA_STATISTIC_CATEGORY',
        });
    };
}

export function setStatisticsViewType(payload) {
    return dispatch => {
        dispatch({
            payload,
            type: 'JIRA_STATISTIC_VIEWTYPE',
        });
    };
}

export function fetchStatisticsValues() {
    return apiRequestActionCreator({
        actionName: 'JIRA_STATISTICS_VALUES',
        params: {
            url: 'jira/statistics/values',
        },
    });
}

export const jiraStatisticsPermissions = {
    fetchStatistics: CS_API_ROLES.JIRA_READ,
    fetchStatisticsValues: CS_API_ROLES.JIRA_READ,
};
